import React, { useRef } from 'react';
import { content } from '../data/content';
import { useReveal } from '../hooks/useReveal';

const Publications = ({ language }) => {
    const t = content[language].publications;
    const root = useRef(null);

    useReveal(root);

    const renderAuthors = (authorString) => {
        const parts = authorString.split('**');
        return parts.map((part, index) => {
            if (part === 'Yeh, S.P.') {
                return <strong key={index} className="text-blue-600 dark:text-blue-400">{part}</strong>;
            }
            return <span key={index}>{part}</span>;
        });
    };

    return (
        <div ref={root} className="min-h-screen pt-24 pb-16 px-4 container mx-auto">
            <h1 className="reveal text-4xl font-bold text-center mb-12 text-gray-800 dark:text-white">
                {t.title}
            </h1>

            <div className="max-w-4xl mx-auto space-y-12">
                {/* Journal Papers */}
                <section>
                    <h2 className="reveal text-2xl font-bold mb-6 text-gray-800 dark:text-white flex items-center gap-3 border-b pb-2 border-gray-200 dark:border-gray-700">
                        <i className="fas fa-book-open text-blue-500"></i>
                        {t.journalTitle}
                    </h2>
                    <div className="space-y-6">
                        {t.journals.map((paper, index) => (
                            <div
                                key={index}
                                className="reveal-card bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-green-500"
                            >
                                <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-2">"{paper.title}"</h3>
                                <p className="text-gray-600 dark:text-gray-300 mb-2 text-sm">
                                    {renderAuthors(paper.authors)}
                                </p>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="font-medium text-blue-600 dark:text-blue-400 italic">{paper.journal}</span>
                                    <span className="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-gray-600 dark:text-gray-400">{paper.year}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Conference Papers */}
                <section>
                    <h2 className="reveal text-2xl font-bold mb-6 text-gray-800 dark:text-white flex items-center gap-3 border-b pb-2 border-gray-200 dark:border-gray-700">
                        <i className="fas fa-users text-blue-500"></i>
                        {t.conferenceTitle}
                    </h2>
                    <div className="space-y-6">
                        {t.conferences.map((paper, index) => (
                            <div
                                key={index}
                                className="reveal-card bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-purple-500"
                            >
                                <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-2">"{paper.title}"</h3>
                                <p className="text-gray-600 dark:text-gray-300 mb-2 text-sm">
                                    {renderAuthors(paper.authors)}
                                </p>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="font-medium text-purple-600 dark:text-purple-400 italic">{paper.conference}</span>
                                    <span className="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-gray-600 dark:text-gray-400">{paper.year}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Publications;
